import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import { loadRegistrationCodes } from '../../../../../state/modules/registrationCodes/actions';
import RegistrationCodeInput from '../components/RegistrationCodeInput';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const defaultLimit = 10;
const defaultOrder = 'id.asc';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  // merge results for all modules
  const results = [].concat.apply(
    [],
    Object.entries(
      state.registrationCodes.getIn(['pages', defaultOrder, defaultLimit], {})
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['registrationCodes', x]),
              schema.registrationCode,
              state.entities.toJS()
            ),
          };
        })
      : [];
  return {
    options: list,
    isLoading: state.registrationCodes.get('isLoading'),
    partnershipId,
    defaultLimit,
    defaultOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      partnershipId,
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      filter = {},
      cb = function () {}
    ) => {
      dispatch(
        loadRegistrationCodes(
          partnershipId,
          page,
          limit,
          order,
          filter,
          (success, total) => {
            if (success) {
              // loop over all pages to get all events
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(loadRegistrationCodes(partnershipId, i, limit, order));
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const RegistrationCodeInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationCodeInput);

export default RegistrationCodeInputContainer;
